import React from 'react'
import styled from 'styled-components'
import ZapVideo from './ZapVideo'
import styles from '../../utility/styles'

const Wrapper = styled.div`
	position: fixed;
	top: env(safe-area-inset-top);
	left: env(safe-area-inset-left);
	right: env(safe-area-inset-right);
	bottom: 0;
	background-color: ${styles.functions.opacityModifier(
		styles.colors.background,
		80
	)};
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	@media screen and ${styles.breakpoints.desktop} {
		top: calc(75px + env(safe-area-inset-top));
	}
	@media screen and (max-width: 798px), screen and (max-height: 450px) {
		top: env(safe-area-inset-top);
		left: 0;
		right: 0;
	}
`

/**
 *
 * @param {{
 *   currentZap:string,
 *   close:()=>void
 * }} props
 * @returns
 */
export default function ZapModal({ currentZap, close }) {

	if (!currentZap) return false

	return (
		<Wrapper>
			<ZapVideo source={currentZap} {...{ close }} />
		</Wrapper>
	)
}
